$(() => {
	$('.contact-item').on('click', '.contact-item__heading', function() {
		var arrow = $(this).find('span'),
			dropdown = $(this).next('.contact-item__dropdown'),
			angle;

		if ( !dropdown.is(':visible') ) {
			angle = 90;
		} else {
			angle = 0;
		}

		arrow.animate(
			{
				deg: angle
			},
			{
				duration: 400,
				step: function(now) {
					arrow.css({
						transform: 'rotate(' + now + 'deg)'
					});
				}
			}
		);

		dropdown.slideToggle();
	});
});